import Index from './index.vue'
import List from './components/List.vue'
import Create from './components/Create.vue'
// import Profile from './view/Profile.vue'
import Edit from './components/Edit.vue'


export default [
  {
    path: 'user',
    name: 'user',
    component: Index,
    title: 'User',
    redirect: { name: 'user-list' },
    children: [
      {
        path: 'list',
        name: 'user-list',
        component: List,
      },
      {
        path: 'create',
        name: 'user-create',
        component: Create,
      },
      {
        path: 'edit/:id',
        name: 'user-edit',
        component: Edit,
      },
      // {
      //   path: 'profile/:id',
      //   name: "user-profile",
      //   component: Profile
      // }
    ],
    
  },
]
